var exports = {
  "y": "x1cb7f6e3--16e055--mobile-btn",
  "l": "x1cb7f6e3--16e055--mobile-wrapper",
};

module.exports = exports;
